import Input from "../../input";
import { TextControlProps } from "../types";

export default function TextControl(
  props: Readonly<Omit<TextControlProps, "type">>,
) {
  const {
    rows = 1,
    value,
    trim = true,
    onChange,
    onBlur,
    getInputRef,
    ...rest
  } = props;

  return (
    <Input
      {...rest}
      as={rows > 1 ? "textarea" : "input"}
      rows={rows}
      type="text"
      value={value}
      onChange={(e) =>
        onChange?.(trim ? e.target.value?.trimStart() : e.target.value)
      }
      onBlur={(e) => {
        onBlur?.();
        if (trim && e.target.value) onChange?.(e.target.value.trim());
      }}
      ref={getInputRef}
    />
  );
}
